exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\r\n\r\n\r\n.MyPanelClass{\r\n    border:solid;\r\n \r\n    padding: 1em;\r\n    background-color: #f5f5f5;\r\n    border: 1px solid #e3e3e3;\r\n    color:#333;\r\n    border-radius: 4px;\r\n\r\n\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n", ""]);

